// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productDiscountLabel":"productDiscountLabel_qIg7x"};